import React, { useEffect } from 'react';
import '../TermsModal/TermsModal.css';

const PrivacyModal = ({ isOpen, onClose }) => {
  // Disable body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="terms-backdrop" onClick={onClose}>
      <div className="terms-modal" onClick={(e) => e.stopPropagation()}>
        <div className="terms-header">
          <div className="terms-title-group">
            <i className="fa-solid fa-user-shield terms-icon"></i>
            <h3>Política de Privacidad</h3>
          </div>
          <button className="terms-close-btn" onClick={onClose} aria-label="Cerrar modal">
            <i className="fa-solid fa-xmark"></i>
          </button>
        </div>

        <div className="terms-body">
          <h2>POLÍTICA DE PRIVACIDAD Y PROTECCIÓN DE DATOS PERSONALES</h2>

          <div className="terms-section">
            <h4>1. IDENTIDAD Y DOMICILIO DEL TITULAR DEL BANCO DE DATOS</h4>
            <p>
              El titular del tratamiento de los datos personales es <strong>Cash Sol S.A.C.</strong>, identificado con RUC N° 20604951268, con domicilio fiscal en Av. Carlos Eyzaguirre Mza. a Lote. 18, Lima, Perú.
            </p>
          </div>

          <div className="terms-section">
            <h4>2. BANCO DE DATOS</h4>
            <p>
              Los datos de carácter personal recopilados a través de nuestro formulario de registro serán almacenados en nuestro banco de datos denominado "Usuarios del Portal Web", el cual se encuentra registrado (o en proceso de inscripción) ante el Registro Nacional de Protección de Datos Personales de la Autoridad Nacional de Protección de Datos Personales (ANPD).
            </p>
          </div>

          <div className="terms-section">
            <h4>3. FINALIDADES OBLIGATORIAS DEL TRATAMIENTO</h4>
            <p>
              Cash Sol tratará sus datos personales con las siguientes finalidades estrictamente necesarias para la ejecución de la relación contractual o precontractual:
            </p>
            <ul>
              <li>Validar la identidad del Usuario ante el Registro Nacional de Identificación y Estado Civil (RENIEC).</li>
              <li>Evaluar el perfil crediticio, capacidad de pago y nivel de riesgo del Usuario, lo cual incluye realizar consultas en centrales de riesgo privadas (como Equifax/Infocorp).</li>
              <li>Gestionar la creación, mantenimiento y seguridad de su cuenta en el Portal.</li>
              <li>Gestionar el desembolso del préstamo, la facturación, el cobro de las cuotas y las acciones de cobranza en caso de atraso.</li>
              <li>Atender consultas, reclamos y solicitudes de soporte técnico.</li>
            </ul>
          </div>

          <div className="terms-section">
            <h4>4. FINALIDADES OPCIONALES (COMERCIALES)</h4>
            <p>
              Solo si el Usuario otorga su consentimiento expreso marcando la casilla opcional en el registro, Cash Sol podrá tratar sus datos para:
            </p>
            <ul>
              <li>Enviar ofertas comerciales, promociones de créditos, publicidad de productos financieros propios o de socios estratégicos a través de correo electrónico, SMS, llamadas telefónicas o WhatsApp.</li>
            </ul>
          </div>

          <div className="terms-section">
            <h4>5. TRANSFERENCIA Y FLUJO TRANSFRONTERIZO DE DATOS</h4>
            <p>
              Para cumplir con las finalidades descritas, Cash Sol podrá transferir sus datos a:
            </p>
            <ul>
              <li>Empresas de evaluación crediticia y Centrales de Riesgo (Ej. Sentinel Perú S.A.).</li>
              <li>Entidades financieras y pasarelas de pago para procesar los depósitos y recaudar las cuotas.</li>
              <li>
                <strong>Proveedores de servicios en la nube (Hosting):</strong> Los datos pueden ser almacenados en servidores de terceros (como AWS, Google Cloud o Azure) ubicados fuera del Perú, lo que constituye un flujo transfronterizo de datos, garantizando niveles adecuados de seguridad.
              </li>
            </ul>
          </div>

          <div className="terms-section">
            <h4>6. PLAZO DE CONSERVACIÓN</h4>
            <p>
              Los datos personales se conservarán mientras dure la relación contractual y, posteriormente, por un plazo de hasta diez (5) años, de conformidad con las normas de prescripción legal en materia civil y financiera en el Perú. Si la solicitud de crédito es rechazada, los datos se conservarán por un periodo de 1 año para fines de auditoría y prevención de fraudes.
            </p>
          </div>

          <div className="terms-section">
            <h4>7. EJERCICIO DE DERECHOS ARCO</h4>
            <p>
              El Usuario puede ejercer en cualquier momento sus derechos de Acceso, Rectificación, Cancelación y Oposición (Derechos ARCO) conforme a la Ley N° 29733. Para ello, deberá enviar una solicitud escrita adjuntando copia de su DNI al correo electrónico <strong>Cashsolperuclientes@gmail.com</strong>.
            </p>
          </div>

          <div className="terms-section">
            <h4>8. MODIFICACIONES A LA POLÍTICA</h4>
            <p>
              Cash Sol se reserva el derecho de modificar esta política para adaptarla a novedades legislativas. Cualquier cambio sustancial será notificado al Usuario a través del Portal o por correo electrónico antes de su entrada en vigor.
            </p>
          </div>
        </div>

        <div className="terms-footer">
          <button className="btn-primary terms-accept-btn" onClick={onClose}>
            Entendido
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrivacyModal;
